'use strict'

import {loadInsight} from './insights'
import {trackEvent} from '../analytics/index'

export function attachHandlers(el, insightsDataCache) {
  const card = el.querySelector('.card')
  const intro = el.querySelector('.intro')
  const anchorShow = el.querySelector('a[data-action="show"]')
  const anchorMore = el.querySelector('a[data-action="more"]')
  const insightsType = insightsDataCache.insightsType === 'segments--consumers' ? 'Consumer Insights' : 'Trend Insights'

  anchorShow.addEventListener('click', e => {
    e.preventDefault()
    card.classList.remove('card--bounce')
    card.classList.add('card--loaded')
    intro.classList.add('intro--hide')
    trackEvent(insightsType, 'Click', 'Button', 'Show Me!')
    window.setTimeout(() => {
      card.classList.add('card--faster')
    }, 2000)
  })

  anchorMore.addEventListener('click', e => {
    e.preventDefault()

    if (insightsDataCache.isGettingData) {
      return
    }

    card.classList.add('card--throw-away')
    card.classList.add('card--hide-lines')
    trackEvent(insightsType, 'Click', 'Button', 'What else?')

    window.setTimeout(() => {
      loadInsight(insightsDataCache)
      card.classList.remove('card--throw-away')
    }, 600)

    window.setTimeout(() => {
      card.classList.remove('card--hide-lines')
    }, 1100)
  })
}
